import { isStorybookMode, addStorybookToDevMenu } from "./sherlo";

export { isStorybookMode, addStorybookToDevMenu };
